import * as React from 'react';

import * as main from '../../../styles/mainOld.module.scss';
import * as courseModule from './courseModule.module.scss';

export const CourseModuleFive = ({ badgeText, resultText }) => {
  return (
    <section className={courseModule.courseModule}>
      <div className="container">
        <p className={courseModule.courseModule__important}>{badgeText} 5</p>
        <h3 className={courseModule.courseModule__subtitle}>Личная эффективность (soft skills)</h3>
        <p className={courseModule.courseModule__description}>
          Как езда на&nbsp;автомобиле сильно отличается от&nbsp;езды на&nbsp;велосипеде, так и&nbsp;новая скорость
          в&nbsp;работе с&nbsp;информацией требует других навыков личной эффективности. Мы сделали все, чтобы ребенок
          осознал свои новые возможности и&nbsp;научился использовать их&nbsp;на&nbsp;100%
        </p>
        <div className={`row ${courseModule.courseModule__row}`}>
          <div className="col-12 col-lg-9">
            <p className={courseModule.courseModule__listTitle}>Формируемые навыки:</p>
            <ul className={courseModule.courseModule__list}>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>Планирование с&nbsp;опорой на&nbsp;собственный опыт</p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>Целеполагание по&nbsp;технологии SMART</p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>Самостоятельно ставить и&nbsp;выполнять учебный план</p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>Разбивать большие задачи на&nbsp;посильные подзадачи</p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>Управление временными ресурсами (тайм-менеджмент)</p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>
                  Алгоритмы работы с&nbsp;информацией для повышения скорости и&nbsp;качества ее обработки
                </p>
              </li>
              <li className={courseModule.courseModule__item}>
                <p className={courseModule.courseModule__text}>
                  Осознавать свои навыки, усиливать имеющиеся и&nbsp;осваивать новые
                </p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemDouble}`}>
                <p className={courseModule.courseModule__itemDouble__text}>
                  Навык саморефлексии, позволяющий самостоятельно оценить результат учебы или интеллектуального труда
                  по&nbsp;критериям знаю/не знаю, качественно/не качественно, в&nbsp;срок/не в&nbsp;срок и&nbsp;т.д.
                </p>
              </li>
            </ul>
          </div>
          <div className={`col-12 col-lg-3 ${courseModule.courseModule__sideData}`}>
            <div className={main.sideData}>
              <p className={main.sideData__bigTextAccent}>15%</p>
              <p className={main.sideData__smallText}>
                наших выпускников переходят на&nbsp;экстернат или самостоятельно осваивают новые профессии
              </p>
            </div>
            <div className={main.sideData}>
              <p className={main.sideData__smallText}>
                <b>Понимание механизма управления жизнью через управление портфелем своих компетенций</b>
              </p>
            </div>
          </div>
        </div>

        <div className={courseModule.courseModule__result}>
          <h3 className={courseModule.courseModule__resultTitle}>{resultText}</h3>
          <div className="row">
            <div className={`col-12 col-md-6 col-lg-4 ${courseModule.courseModule__resultCol}`}>
              <p className={courseModule.courseModule__resultText}>
                Уверенность в&nbsp;достижении любой цели и&nbsp;умение разложить путь к&nbsp;цели на&nbsp;реально
                выполнимые этапы расширяет горизонт мышления и&nbsp;позволяет видеть во&nbsp;всем возможности
              </p>
            </div>
            <div className={`col-12 col-md-6 col-lg-4 ${courseModule.courseModule__resultCol}`}>
              <p className={courseModule.courseModule__resultText}>
                Умение оценивать уровень развития навыков с&nbsp;точки зрения их достаточности или недостаточности для
                достижения любой важной цели
              </p>
            </div>
            <div className={`col-12 col-md-6 col-lg-4 ${courseModule.courseModule__resultCol}`}>
              <p className={courseModule.courseModule__resultText}>
                Умение осознавать свои навыки и&nbsp;способности и&nbsp;работать с&nbsp;ними, как с&nbsp;портфелем
                инструментов, самостоятельно ставя цели на&nbsp;освоение новых навыков или вывод на&nbsp;более высокую
                эффективность уже имеющихся
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
